import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";
import instance from "./instance";

export function getMembership(registeringAs, promoCode) {
	return instance.get(`${apiUrl}/membership/getMembership?registeringAs=${registeringAs}&promoCode=${promoCode}`, aanpAuthOptions()).then(r => r.data);
}